var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"top"},[_c('a',{on:{"click":_vm.goToFeedBack}},[_c('icon-font',{attrs:{"type":"icon-order_icon_lianxidianjia"}})],1),_c('a',{on:{"click":_vm.goToSet}},[_c('icon-font',{attrs:{"type":"icon-icon_shezhi"}})],1),_c('message',{attrs:{"color":"#000"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }